// extracted by mini-css-extract-plugin
export default {"joinVideoBtn":"JoinVideoButton_joinVideoBtn__vVTmL"};